// extracted by mini-css-extract-plugin
export default {"textarea":"dNsW2g","textarea--form":"TD2c8f","textareaForm":"TD2c8f"};